@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.actor {
  @include md-sohne-medium;

  [data-autopilot-system-redesign='on'] & {
    @include sm-sohne-medium;
  }
}
